import { html, css, unsafeCSS, nothing } from 'lit';
import SotbitButton from '../button';
import styles from './button-info.scss?inline';

export default class SotbitButtonInfo extends SotbitButton {
    static styles = [
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = SotbitButton.properties;

    render() {
        const aria = this.ariaLabel ? this.ariaLabel : (this.dataTooltip ?? '');

        return html`
            <div class="wrapper" part="wrapper">
                <button
                    ?disabled="${this.disabled}"
                    part="button"
                    type="${this.type || nothing}"
                    form="${this.form || nothing}"
                    name="${this.name || nothing}"
                    value="${this.value || nothing}"
                    class="btn"
                    aria-label="${aria}"
                >
                    <div class="background" part="background"></div>
                    <slot name="icon">
                        <sotbit-icon icon="info" size="s" no-padding></sotbit-icon>
                    </slot>
                </button>
                <slot></slot>
            </div>
        `;
    }
}
